import script from "./AccordionBodyDevTools.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionBodyDevTools.vue?vue&type=script&setup=true&lang=js"

import "./AccordionBodyDevTools.vue?vue&type=style&index=0&id=62504008&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62504008"]])

export default __exports__